module.exports = __webpack_public_path__ + "static/media/Italian_traffic_signs_Strettoia_Simmetrica-BN.9b8b10c8.svg";